<div class="container">
  <nav class="navbar">

    <div style="flex-basis: 40%; justify-content: flex-start;" class="nav-button">
      <app-nav-button (click)="onNavigate('team')">Our Team</app-nav-button>
      <app-nav-button (click)="onNavigate('hours')">Hours</app-nav-button>
      <app-nav-button (click)="onNavigate('about')">About</app-nav-button>
    </div>

    <div
      style="flex-basis: 200px; display: flex; flex-direction: column; justify-content: center; align-items: center;margin-top: 1em;">
      <h1 id="main-barbershop">BARBERSHOP</h1>
      <h1 id="main-denim">DENIM</h1>
    </div>

    <div style="flex-basis: 40%; justify-content: flex-end;" class="nav-button">
      <app-nav-button (click)="onNavigate('products')">Services</app-nav-button>
      <app-nav-button (click)="onNavigate('gallery')">Gallery</app-nav-button>
      <app-nav-button (click)="onNavigate('location')">Map</app-nav-button>
    </div>
  </nav>

  <ng-container *ngIf="isTooNarrow$ | async as isTooNarrow">
    <ng-container *ngIf="isMobile$ | async as isMobile">
      <ng-container *ngIf="showMargins$ | async as showMargins">
        <div class="frame" *ngIf="triggerAnimation$ | async as animation" 
          [ngClass]="{'tooNarrow': isTooNarrow === 'YES', 'animateIn': animation === 'YES'}"
          [ngStyle]="{'margin': showMargins === 'YES' ? '0 20px' : '0'}">
          <video [autoplay]="true" loop [muted]="true" playsinline preload="metadata" poster="assets/media/video_bg_2.jpg" *ngIf="isMobile === 'YES'; else horz">
            <source src="assets/media/denim_new_vid_vertical.mp4" type="video/mp4">
          </video>
          <ng-template #horz>
            <video style="position: relative; top: -30px; height: calc(100% + 70px)" [autoplay]="true" loop [muted]="true" playsinline preload="metadata" poster="assets/media/video_bg_2.jpg">
              <source src="assets/media/denim_new_vid_horizontal.mp4" type="video/mp4">
            </video>
          </ng-template>

          <div class="header-content">
            <div class="more-content" [ngStyle]="{'bottom': isMobile === 'YES' ? '100px' : '20%'}">
              <div class="book-button" (click)="onBook()">
                <h1>BOOK NOW</h1>
              </div>
              <div style="text-align: center">
                <h2 class="subtitle">1517 South Street Philadelphia, PA 19146</h2>
                <h3 class="subtitle">(267) 930-3980</h3>
              </div>
              <div style="display: flex; width: 200px; justify-content: space-around; color: white;">
                <i class="fab fa-instagram fa-3x" style="cursor: pointer;" (click)="onInsta()"></i>
                <i class="fab fa-yelp fa-3x" style="cursor: pointer;" (click)="onYelp()"></i>
                <i class="far fa-envelope fa-3x" style="cursor: pointer;" (click)="onEmail()"></i>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
